import { Fragment, FunctionalComponent, h } from 'preact';
import { useEffect } from 'preact/hooks';

import { i18nTranslate } from 'common/helper/i18n/translate';
import { GoogleRecaptchaTemplate } from 'common/module/google/recaptcha/template';
import { LoaderComponent } from 'common/module/loader/component';
import { UserRegistrationTemplatePropsInterface } from 'common/module/user/registration/template-props.interface';

export const UserRegistrationTemplateRefactored: FunctionalComponent<UserRegistrationTemplatePropsInterface> = (
  props
) => {
  useEffect(() => {
    props.onReset();
  }, []);

  return (
    <Fragment>
      <div className='authentication__content'>
        <form onSubmit={props.onSubmit}>
          {props.error && <div className='authentication__error--general'>{props.error}</div>}
          <div className='authentication__form'>
            <div className='authentication__input-area'>
              <input
                type='text'
                className='authentication__input authentication__input--refactored'
                placeholder={i18nTranslate('Email')}
                value={props.fields.email}
                onChange={(e) => props.onChangeInput(e, 'email')}
              />
              <div className='authentication__error'>{props.fieldErrors.email}</div>
            </div>
            <div className='authentication__input-area'>
              <input
                type={props.isPasswordVisible ? 'text' : 'password'}
                className='authentication__input authentication__input--refactored'
                placeholder={i18nTranslate('Password')}
                value={props.fields.password}
                onChange={(e) => props.onChangeInput(e, 'password')}
              />
              <button
                type='button'
                className='authentication__input-area-password-show-hide--refactored'
                onClick={() => props.setIsPasswordVisible(!props.isPasswordVisible)}
              >
                {i18nTranslate(props.isPasswordVisible ? 'Hide' : 'Show')}
              </button>
              <div className='authentication__input-area-password-requirements--refactored'>
                {i18nTranslate('The password should contain at least two numbers')}
              </div>
              <div className='authentication__error'>{props.fieldErrors.password}</div>
            </div>

            <div className='authentication__form-submit'>
              <button type='submit' className='authentication__form-submit-button--refactored button'>
                {i18nTranslate('Create account')}
              </button>
            </div>

            {!props.isAdditionalConditionEnabled && (
              <div className='authentication__policy-check'>
                <button
                  type='button'
                  className='authentication__checkbox-area authentication__input-area'
                  onClick={props.onClickOptedIn}
                >
                  <div
                    className={`authentication__checkbox
                    ${props.fields.opted_in ? 'authentication__checkbox--checked' : ''}`}
                  >
                    <span className='svg'>
                      <svg viewBox='0 0 12 9' className='authentication__checkbox-icon'>
                        <use xlinkHref='#svg-check-icon' />
                      </svg>
                    </span>
                  </div>
                  <div className='authentication__checkbox-text authentication__checkbox-text--small--refactored'>
                    {i18nTranslate(
                      'Send me free guides, market price trends and property recommendations to help my search.'
                    )}
                  </div>
                </button>
              </div>
            )}

            <div className='authentication__input-area'>
              <GoogleRecaptchaTemplate {...props.captcha} />
              <div className='authentication__error'>{props.fieldErrors.captcha_token}</div>
            </div>
          </div>
        </form>
      </div>
      <LoaderComponent isEnabled={props.loaderEnabled} isCentered={true} />
    </Fragment>
  );
};
